import React, { useState } from "react";
import { Navigate } from "react-router-dom";

const SeferPetachProvider = ({ children }) => {
  const [token] = useState(localStorage.getItem("holocron"));

  if (!token) {
    return (
      <Navigate to="/login" replace />
    );
  }
  else {
    return (
      <>
        {children}
      </>
    );
  }
};
export { SeferPetachProvider };